import { endPoints } from 'api/';

/**
  @description Replaces the warehouses a user is assigned to. Called from inside
  the `request` of createUser and updateUser so saving a user stays one action.
  @param {Function} apiClient
  @param {string} userId
  @param {string[]} warehouseIds Every warehouse the user should have, an empty array removes them all.
 */
function assignUserWarehouses(apiClient, userId, warehouseIds) {
  return apiClient(
    endPoints.UPDATE_USER_WAREHOUSES,
    { warehouse_ids: warehouseIds },
    { userId },
  );
}

export default assignUserWarehouses;
